import { render } from "./VerticalButtons.vue?vue&type=template&id=96b5dfe2"
const script = {}

import "./VerticalButtons.vue?vue&type=style&index=0&id=96b5dfe2&lang=scss"

import exportComponent from "/media/shared/vue/imgcropper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__